module.exports = __webpack_public_path__ + "img/calendar.9a1f65b3.svg";